export default (() => {

    const global = { 
        elements: {},
        pageData: {},
        requestData: {}
    };

    function initialise () {
        _initialiseData();
        _bindEvents();
    }

    function _initialiseData () {
        global.requestData.dismissUrl = document.querySelector('[data-update-dismissed-url]').getAttribute('data-update-dismissed-url');
    }

    function _bindEvents () {
        document.querySelectorAll('[data-announcement]').forEach((element) =>_setAnnouncementCloseClick(element, global.requestData.dismissUrl));
    }

    function _setAnnouncementCloseClick (element, endpoint) {
        const contributorPorfolioId = element.getAttribute('data-announcement-id');

        element.oncloseclick = _storeAnnouncementDismissal.bind(null, contributorPorfolioId, endpoint);
    }

    function _storeAnnouncementDismissal (id, endpoint) {
        const config = {
            url: `${endpoint}/${id}`,
            method: 'PUT'
        };
        
        wealthify.request.send(config);
    }

    return { initialise };
})();